import { ContactType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import {
  ContactPickerField,
  ContactPickerFieldProps
} from "@ui-components/pickers/contact-picker/ContactPickerField.tsx";

/**
 * Use PatientPickerField when requiring a PatientPicker within react final form.
 * @param props
 */
export const PatientPickerField = (props: ContactPickerFieldProps) => (
  <ContactPickerField filter={{ types: [ContactType.Patient] }} {...props} />
);
